import { useEffect } from 'react';
import { useFreeTrialUpgradeModal } from './common/modals/FreeTrialUpgradeModal/use-free-trial-upgrade-modal';
import moment from 'moment';
import { IS_PROD_URL } from '@mm/utils';

const key = 'free_trial_upgrade_promo_last_seen';

export const useSubscribeFromTrialPromoModal = () => {
  const modal = useFreeTrialUpgradeModal();

  useEffect(() => {
    if (modal.isFreeTrialPromotionWithoutSubscription) {
      const time = localStorage.getItem(key);

      if (
        time &&
        moment().diff(
          moment(parseInt(time, 10)),
          IS_PROD_URL ? 'hours' : 'minutes',
        ) < 12
      ) {
        return;
      }

      localStorage.setItem(key, moment.now().toString());
      modal.openFreeTrialUpgradeModalPromotional();
    }
  }, [modal.isFreeTrialPromotionActive]);
};
